<script setup lang="ts">
import IconLoading from '~icons/mdi/loading'
</script>

<template>
  <IconLoading
    class="animate-spin text-primary-500"
  />
</template>

<style>
</style>
